import { UploadStatus } from '@/store/reducers/uploads-queue/types';
import { BucketFileCategory } from '@/types';

export const BucketUndefined = 'BucketUndefined';

export type UploadDTO = {
  bucketId: string;
  category: BucketFileCategory;
  file: File;
  overwriteName?: string;
  id: string;
  uploadStatus: UploadStatus;
};

export enum ErrorMessage {
  EmptyFileType = 'Select file type to upload',
  ExceedsFileSize = 'File exceed the 40MB limit',
  ForbiddenFileExtension = 'This file type is not supported',
  ContractIsApproved = 'The customer contract is already approved and cannot be replaced',
}

export enum UploadFileType {
  'Utility Bill' = 0,
  'Contract' = 1,
  'Site Photos' = 2,
  'Roofer Proposal Feedback' = 3,
  'Roofing Permit' = 4,
  'Installation Photo' = 5,
  'Construction Plans' = 6,
}

export type Upload = {
  id: string;
  bucketId: string | null;
  name: string;
  fileType: UploadFileType | null;
  thumbnail: string | null;
  error: ErrorMessage | null;
  file: File;
  uploadStatus: UploadStatus;
  activityId: string | null;
};
